import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { isEqual } from 'lodash'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

import { Box } from '@chatterbug/aaron'

const reorder = (list, from, to) => {
  const result = Array.from(list)
  const [removed] = result.splice(from, 1)
  result.splice(to, 0, removed)
  return result
}

const ListSkeleton = ({
  titleSection,
  items,
  ItemComponent,
  DropPlaceholderComponent,
  draggable,
  removable,
  onReorder,
  onRemove,
}) => {
  const [itemsBeforeReordering, setItemsBeforeReordering] = useState(items)
  const [itemsToReorder, setListItems] = useState(items)

  useEffect(() => {
    if (!isEqual(items, itemsBeforeReordering)) {
      setListItems(items)
      setItemsBeforeReordering(items)
    }
  }, [items, itemsBeforeReordering, setListItems, setItemsBeforeReordering])

  const handleOnDragEnd = (result) => {
    if (!result.destination) {
      return
    }

    const from = result.source.index
    const to = result.destination.index
    const movingItem = itemsToReorder[from]
    setListItems(reorder(itemsToReorder, from, to))
    onReorder?.({ unit: movingItem, from, to })
  }

  return (
    <DragDropContext onDragEnd={handleOnDragEnd}>
      <Box>
        <Box mb="2x" variant="text.h5">
          {titleSection}
        </Box>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <Box
              as="ul"
              {...provided.droppableProps}
              ref={provided.innerRef}
              sx={{
                padding: 0,
                listStyle: 'none',
                position: 'relative', // to allow custom DropPlaceholderComponent
              }}
            >
              {snapshot.isDraggingOver && DropPlaceholderComponent && (
                <DropPlaceholderComponent />
              )}
              {itemsToReorder.map((item, index) => (
                <Draggable
                  key={item.id}
                  draggableId={item.id}
                  index={index}
                  isDragDisabled={!draggable}
                >
                  {(provided) => (
                    <Box
                      as="li"
                      mb="3x"
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      sx={{
                        position: 'relative', // to allow custom DropPlaceholderComponent
                      }}
                    >
                      <ItemComponent
                        {...item}
                        draggable={draggable}
                        removable={removable}
                        onRemove={() => onRemove(item)}
                      />
                    </Box>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </Box>
          )}
        </Droppable>
      </Box>
    </DragDropContext>
  )
}

ListSkeleton.propTypes = {
  titleSection: PropTypes.any,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
    })
  ).isRequired,
  ItemComponent: PropTypes.func.isRequired,
  DropPlaceholderComponent: PropTypes.func,
  draggable: PropTypes.bool,
  removable: PropTypes.bool,
  onReorder: PropTypes.func,
  onRemove: PropTypes.func,
}

export default ListSkeleton
